import React from 'react';
import Helmet from 'react-helmet';
import Waypoint from 'react-waypoint';

import fullname from 'utils/fullname';
import Employees from 'api/resources/employees';
import { processErrorByAlert } from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import Employee from 'admin-moderator/containers/Employee';
import CreateEmployee from 'admin-moderator/containers/CreateEmployee';
import UserCardStub from 'admin-moderator/components/UserCardStub';

import IconUsers from 'icons/Users';

import RightColumn from 'styled/Page/RightColumn';

import Main from 'styled/Page/Main';
import CenteredContainer from 'styled/Page/CenteredContainer';
import ErrorText from 'styled/Page/ErrorText';
import GridList from 'styled/Page/GridList';

const PAGE_SIZE = 20;

export class EmployeesPage extends React.PureComponent {
  state = {
    employees: [],
    hasMore: false,
    loading: false,
  };

  componentDidMount() {
    this.loadEmployees();
  }

  get cursor() {
    if (this.state.employees.length === 0) return undefined;
    return this.state.employees[this.state.employees.length - 1].id;
  }

  handleRolesChange = (employee) => {
    this.setState(prevState => ({
      employees: prevState.employees.reduce((acc, item) => acc.concat(item.id === employee.id ? employee : item), []),
    }));
  }

  handleEmployeeCreate = (employee) => {
    this.setState(prevState => ({
      employees: [employee].concat(prevState.employees),
    }));
  }

  handleDelete = (employee) => {
    this.setState(prevState => ({
      employees: prevState.employees.filter(item => item.id !== employee.id),
    }));
  }

  loadEmployees = async () => {
    this.setState({ loading: true });

    try {
      const response = await Employees.getAll({
        page: {
          cursor: this.cursor,
          size: PAGE_SIZE,
        },
        filter: { is_disabled: false },
        include: 'avatar',
        fields: {
          employee: 'first_name,last_name,email,roles,avatar',
        },
      });

      const employees = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState(prevState => ({
        employees: employees.reduce((acc, currentValue) => {
          if (acc.find(item => item.id === currentValue.id)) {
            return acc;
          }

          return acc.concat(currentValue);
        }, prevState.employees),
        loading: false,
        hasMore: employees.length === PAGE_SIZE,
      }));
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <Main>
        <Helmet><title>Сотрудники</title></Helmet>

        <div style={{ width: '100%', padding: '20px 32px 100px' }}>
          <GridList>
            {this.state.employees.map(employee => (
              <Employee
                key={employee.id}
                name={fullname(employee)}
                id={employee.id}
                roles={employee.roles}
                avatar={employee.avatar && employee.avatar.url}
                email={employee.email}
                onDelete={this.handleDelete}
                onRolesChange={this.handleRolesChange}
              />
            ))}

            {this.state.loading && (
              Array.from({ length: PAGE_SIZE }, () => <UserCardStub key={Math.random()} />)
            )}
          </GridList>

          {this.state.employees.length === 0 && !this.state.loading && (
            <CenteredContainer>
              <IconUsers size={80} />

              <ErrorText>Сотрудников не найдено</ErrorText>
            </CenteredContainer>
          )}

          {this.state.hasMore && <Waypoint onEnter={this.loadEmployees} />}
        </div>

        <RightColumn>
          <CreateEmployee onCreate={this.handleEmployeeCreate} />
        </RightColumn>
      </Main>
    );
  }
}

export default EmployeesPage;
